import { useMemo } from 'react';
import { useAtom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { keepPreviousData } from '@tanstack/query-core';
import { toolExecutionLogService } from '@/services';

// One page per request, like the other paged settings tables.
const PAGE_SIZE = 20;

const toolExecutionLogsQueryAtom = (provider: string, tool: string, requestId: string, page: number) =>
  atomWithQuery(() => ({
    queryKey: ['tool-execution-logs', provider, tool, requestId, page],
    queryFn: () => toolExecutionLogService.list(provider, tool, page, PAGE_SIZE, requestId),
    // Keeps the current page (and the pager) on screen while the next one loads.
    placeholderData: keepPreviousData,
    enabled: !!provider && !!tool,
  }));

/** One page of an action's calls, newest first, or only those of `requestId` when it is set. */
export function useToolExecutionLogs(provider: string, tool: string, requestId = '', page = 1) {
  const atom = useMemo(
    () => toolExecutionLogsQueryAtom(provider, tool, requestId, page),
    [provider, tool, requestId, page]
  );
  const [query] = useAtom(atom);
  return query;
}
